/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SelectFile.scss';

const styles = {
  inputFile: {
    display: 'none',
  },
};

class SelectFile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileName: '',
      fileList: null,
      isFileSelected: false,
    };
  }

  onBrowsFile = (e) => {
    this.textInput.click();
  }

  onInputChange = (e) => {
    let fileNames = ''
    for (var i=0; i < e.target.files.length; i++) {
      fileNames += e.target.files[i].name + ', ';
    }

    this.setState({
      fileName: this.props.multiple ? fileNames : e.target.value.replace(/^.*[\\\/]/, ''),
      fileList: this.props.multiple ? e.target.files : e.target.files[0],
    }, () => {
      let isFileSelected = false;
      (this.state.fileList) ? isFileSelected = true : isFileSelected = false;
      this.setState({ isFileSelected }, () => this.props.onFileSelect(this.state));
    });
  }

  componentWillReceiveProps() {
    if (this.props.shouldReset) {
      this.resetComponent();
    }
  }

  resetComponent = () => {
    this.setState({
      fileName: '',
      fileList: null,
      isFileSelected: false,
    });
  }

  render() {
    return (
      <div className={this.props.notFullWidth ? 'asInlineBlock' : 'form-inline'}>
        <label htmlFor="fileText">
          <span onClick={(e) => this.onBrowsFile(e)} className={`btn btn-${this.props.buttonType}`}>
            <i className="glyphicon glyphicon-folder-open" />&nbsp;{this.props.btnText}&hellip; 
            <input
              accept={this.props.accept}
              multiple={this.props.multiple} 
              onChange={(e) => this.onInputChange(e)} 
              ref={(input) => { this.textInput = input; }} 
              type="file"
              style={styles.inputFile}
            />
          </span>
        </label>
        <span onClick={(e) => this.onBrowsFile(e)} className={`fileNameLabel label-${this.props.labelType}`} >{this.state.fileName}</span>
      </div>
    );
  }
}


export default withStyles(s)(SelectFile);



// WEBPACK FOOTER //
// src/components/SelectFile/SelectFile.js